import React, { useState, useEffect } from "react";

const FaqsContent = [
  {
    heading: "What is Heng Ong Bet Malaysia?",
    desc: "Heng Ong Bet Malaysia is a trusted online casino platform where you can play slot games, live casino and more. It is safe, legal and easy to use. ",
  },
  {
    heading: "How do I register and login to Heng Ong Bet?",
    desc: "Go to the Heng Ong Bet Official website, click Register, fill in your details, then log in using your username and password. Fast and simple!",
  },
  {
    heading: "Can I download Heng Ong Bet on Android and iOS?",
    desc: "Yes! You can download the Heng Ong Bet APK for Android or use the Heng Ong Bet iOS version. There's also a browser version called Heng Ong Bet H5.",
  },
  {
    heading: "What bonuses does Heng Ong Bet offer?",
    desc: "New users get a Welcome Bonus and regular players can enjoy Heng Ong Bet Free Credit and special offers during promotions.",
  },
  {
    heading: "What games are available on Hengongbet88 and Hengongbetplay?",
    desc: "You can enjoy exciting Heng Ong Bet Slot games, live dealers and more on platforms like Hengongbet88 and Hengongbetplay—fun and secure!",
  },
];

const FaqItems = ({ faq, key }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = (value) => {
    setIsOpen(value);
  };

  return (
    <>
      <div key={key} className="faq-item">
        <div className="faq-head flex g-10 justify-space-between" onClick={() => handleToggle(!isOpen)}>
          <p>{faq.heading}</p>
          <span className="faq-toggle">{isOpen ? "-" : "+"}</span>
        </div>
        <div className={`faq-body ${isOpen ? "" : "hide"}`}>
          <p>{faq.desc}</p>
        </div>
      </div>
    </>
  );
};

const Faqs = () => {
  return (
    <div className="flex flex-dir-col g-20">
      {FaqsContent.map((faq, i) => {
        return <FaqItems key={i} faq={faq} />;
      })}
    </div>
  );
};

export default Faqs;
